import axios, {HttpStatusCode} from "axios";

export const retrieveHistory = async (username, limit, gameVariant, timeVariant, offset = 0) => {
    let url = `${process.env.REACT_APP_BACKEND_URL}/history/list/${username}?limit=${limit}&offset=${offset}&gameVariant=${gameVariant}`;
    if (timeVariant) {
        url += `&timeVariant=${timeVariant}`;
    }
    const response = await axios.get(url)
    if(response.status !== HttpStatusCode.Ok) {
        throw new Error("Cannot retrieve history, error returned: " + response.status)
    }

    return await response.data;
}

export const retrieveHistoryCount = async (username, gameVariant, timeVariant) => {
    let url = `${process.env.REACT_APP_BACKEND_URL}/history/count/${username}?gameVariant=${gameVariant}`;
    if (timeVariant) {
        url += `&timeVariant=${timeVariant}`;
    }
    return (await axios.get(url)).data.count;
}

export const retrieveStatistics = async (username, gameVariant) => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/history/stats/${username}?gameVariant=${gameVariant}`)).data
}


export const getHistoryForGameId = async (gameId) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/history/${gameId}`, {withCredentials: true})

    return await response.data
}



